export const homeworkDictionary = {
  sending: 'Jo`natilmoqda...',
  homeworkStatus: 'Uy vazifa statusi',
  clickedHomeworkButton: 'Homework yuborish buttoni bosildi',
  clickedExamButton: 'Exam yuborish buttoni bosildi ',
  sendingHomework: 'Jo`natish',
  requirementOfTextArea: 'Uyga vazifa matni bo`sh bo`lmasligi va uzunligi 1000 dan ko`p bo`lishi kerak',
}
